<template>
  <ul class="title" v-if="info && info != {}">
    <li class="select" @click="targetChange('all')">全部</li>
    <li
      v-for="(item, idx) in info"
      :class="activeClass(item)"
      :style="info.movieStyle"
      :key="idx"
      @click="listClick(item)"
    >
      {{ item.name }}
    </li>
  </ul>
</template>

<style scoped>
.title {
  text-align: left;
}
.title b {
  padding: 0px 5px;
  font-size: 20px;
  font-weight: 600;
}
.title span {
  font-size: 15px;
  color: #ccc;
  cursor: pointer;
}
.list {
  text-align: left;
  padding: 10px 0px;
}
.moreType {
  padding: 0px 5px;
  display: inline-block;
  margin: 0px 5px;
  cursor: pointer;
}
.moreType.active,
.moreType:hover {
  color: #46b1c0;
}
</style>

<script>
export default {
  props: {
    info: Object,
  },
  computed: {
    move() {
      return this.$props.info.move ? this.$props.info.move : "更多 >";
    },
    isRadio() {
      return this.$props.info.isRadio;
    },
    list() {
      return this.$props.info.list;
    },
    
  },
  watch: {
    "info.list": function () {
      this.setActive();
    },
  },
  data() {
    return {
      activeList: [],
      objList: [],
      activeName: "",
    };
  },
  methods: {
    /* 添加默认选中 */
    setActive() {
      if (!!this.list && this.list instanceof Array) {
        var that = this;

        that.activeList = [];
        that.objList = [];
        this.list.map(function (item) {
          if (item.isActive) {
            that.activeList.push(item.name);
            that.objList.push(item);
            that.activeName = item.name;
          }
        });
      }
    },
    /* 点击 ‘更多’ 回调 */
    moreClick(info) {
      this.$emit("moreClick", info);
    },
    /* 点击单个类型  参数： item - obj - 单个类型对象 */
    listClick(item) {
      var nIdx = this.activeList.indexOf(item.name);

      var callback;

      if (this.isRadio) {
        this.activeName = item.name;
        callback = item;
      } else {
        if (nIdx < 0) {
          this.activeList.push(item.name);
          this.objList.push(item);
        } else {
          this.activeList.splice(nIdx, 1);
          this.objList.splice(nIdx, 1);
        }
        callback = this.objList;
      }
      // 返回 标签类型数组
      this.$emit("targetChange", callback);
    },
    activeClass(item) {
      if (
        (this.isRadio && item.name == this.activeName) ||
        this.activeList.indexOf(item.name) > -1
      ) {
        return "active";
      }
      return "";
    },
    targetChange() {
      this.$router.push({
        path: "/search",
      });
    },
  },
};
</script>
